import { Box } from '../../../primitives/Box/Box.es.js';
import 'react';
import '../../../primitives/Center/styled.es.js';
import { Group } from '../../../primitives/Group/Group.es.js';
import '../../../primitives/Grid/Grid.es.js';
import '../../../primitives/Level/Level.es.js';
import '../../../primitives/Shelf/Shelf.es.js';
import '../../../primitives/Portal/Portal.es.js';
import '../../../primitives/Hidden/Hidden.es.js';
import '../../../primitives/Media/Media.es.js';
import '../../../primitives/Dialog/Dialog.es.js';
import '../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../primitives/Popper/Popper.es.js';
import '../../../primitives/DragHandle/DragHandle.es.js';
import '../../../primitives/Pin/Pin.es.js';
import styled from 'styled-components';
import '../../../utils/assertions.es.js';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { spacing, radius } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
var GroupWrapper = styled(Group).withConfig({
  componentId: "sc-186e9bl-0"
})(["line-height:1;", " ", ""], function (_ref) {
  var theme = _ref.theme,
      dotSize = _ref.dotSize;
  return dotSize && "height: " + theme.spacing(dotSize) + ";";
}, function (_ref2) {
  var theme = _ref2.theme,
      dotPosition = _ref2.dotPosition,
      dotSize = _ref2.dotSize;
  return dotSize && dotPosition === "inside" && "margin-top: -" + theme.spacing(dotSize) + ";";
});
var GroupItem = styled(Group.Item).withConfig({
  componentId: "sc-186e9bl-1"
})(["position:relative;line-height:1;height:100%;width:", ";"], spacing("md"));
var DotWrapper = styled(Box).withConfig({
  componentId: "sc-186e9bl-2"
})(["position:absolute;top:0;left:0;justify-content:center;cursor:pointer;width:100%;height:100%;"]);
var AbsoluteBox = styled(Box).withConfig({
  componentId: "sc-186e9bl-3"
})(["position:absolute;top:0;left:0;top:calc(50% - ", " / 2);line-height:1;width:", ";height:", ";"], spacing("md"), spacing("md"), spacing("md"));
var Circle = styled(Box).withConfig({
  componentId: "sc-186e9bl-4"
})(["width:100%;height:100%;border-radius:", ";"], radius("round"));
var Styled = {
  GroupWrapper: GroupWrapper,
  GroupItem: GroupItem,
  DotWrapper: DotWrapper,
  AbsoluteBox: AbsoluteBox,
  Circle: Circle
};
export { Styled as default };